<!-- Timetable.vue
  座席予約表を表示するコンポーネント
-->
<template lang="html">
  <div id="timetable">
    <table>
      <ticker></ticker>
      <thead class="tableheader">
        <tr>
          <th class="blank"><rulerHeader></rulerHeader></th>
          <classroomHeader
          v-for="classroom in filteredclassroomNames"
          :key="classroom.name"
          :classroom="classroom.name"></classroomHeader>
        </tr>
      </thead>
      <tbody>
        <tr>
          <th class="tabletimeline"><ruler></ruler></th>
          <td><timelineContainer></timelineContainer></td>
        </tr>
      </tbody>
      <tbody>
        <td></td>
      </tbody>
    </table>
    <informtionPopup></informtionPopup>
    <editingPopup></editingPopup>
    <ReschedulingPopup></ReschedulingPopup>
    <ReservationPopup v-if="$store.state.reservationbox.isPopupShown"></ReservationPopup>
  </div>
</template>

<script>
import Ticker from './SpTicker'
import Ruler from './SpRuler'
import RulerHeader from './SpRulerHeader'
import ClassroomHeader from './SpClassroomHeader'
import TimelineContainer from './SpTimelineContainer'
import InformtionPopup from './boxes/SpInformationPopup'
import EditingPopup from './boxes/SpEditingPopup'
import ReservationPopup from './boxes/SpReservationPopup'
import ReschedulingPopup from './boxes/SpReschedulingPopup'
import {
  mapActions,
  mapGetters
} from 'vuex'
import axios from 'axios'
export default {
  name: 'timetable',
  props: [
  ],
  data () {
    return {
      style: {},
      classrooms: '',
      lastOnlineState: false
    }
  },
  components: {
    ticker: Ticker,
    ruler: Ruler,
    rulerHeader: RulerHeader,
    classroomHeader: ClassroomHeader,
    timelineContainer: TimelineContainer,
    informtionPopup: InformtionPopup,
    editingPopup: EditingPopup,
    ReservationPopup: ReservationPopup,
    ReschedulingPopup: ReschedulingPopup
  },
  methods: {
    ...mapActions([
      'getClassrooms',
      'getReservations',
      'getLectures',
      'getClassrooms',
      'getAttendance'
    ]),
    test () {
      alert(1)
    }
  },
  computed: {
    ...mapGetters([
      'tableWidth',
      'getCurDateFormated'
    ]),
    getStyle () {
      this.style.width = this.tableWidth + 'px'
      return this.style
    },
    filteredclassroomNames () {
      // 一旦教室情報を再取得
      if (this.lastOnlineState !== this.$store.state.showOnline) {
        console.log('getting classrooms')
        this.getClassrooms(this.$store.state.userInfo.school_id)
      }
      this.lastOnlineState = this.$store.state.showOnline
      this.classroom = this.$store.state.classrooms
      if (this.$store.state.showOnline) {
        this.classroom = this.classroom.filter(function (c) {
          return c.name.match(/^オンライン/)
        })
      } else {
        this.classroom = this.classroom.filter(function (c) {
          return !c.name.match(/^オンライン/)
        })
      }
      if (this.$store.state.userInfo.user_type !== 'viewer' && this.$store.state.userInfo.user_id !== 18 && this.$store.state.userInfo.user_type !== 'admin') {
        this.classroom = this.classroom.filter(function (c) {
          return !c.name.match('301')
        })
        this.$store.state.classrooms = this.classroom
        return this.classroom
      }
      this.$store.state.classrooms = this.classroom
      return this.classroom
    }
  },
  mounted () {
    axios.all([
      this.getReservations({
        all: 1,
        date: this.getCurDateFormated,
        school_id: this.$store.state.userInfo.school_id
      }),
      this.$store.dispatch('getLectures', {}),
      this.$store.dispatch('getUserInfo')
    ]).then(axios.spread((res1, res2, res3) => {
      if (this.$store.state.userInfo.user_type === 'admin') {
        this.$store.dispatch('getAttendance')
      }
    }))
    this.getClassrooms(this.$store.state.userInfo.school_id)
    .then(() => {
      this.classrooms = this.$store.state.classrooms
    })
  },
  created () {
    this.getClassrooms(this.$store.state.userInfo.school_id)
    .then(() => {
      this.classrooms = this.$store.state.classrooms
    })
  }
}
</script>

<style lang="css" scoped>
div#timetable {
  overflow: auto;
}
table{
  display: block;
  position: fixed;
  overflow: scroll;
  width: 100%;
  height: calc(90vh);
  border-collapse: collapse;
  font-size: 0;
}
thead, tbody {
  height: auto;
  display: block;
  width: -webkit-max-content;
  width: -moz-max-content;
  width: max-content;
}
th, td {
  display: inline-block;
  background: #fff;
  font-size: 1.0rem;
}
tbody th {
  position: -webkit-sticky;
  position: sticky;
  left: 0;
  z-index: 1;
}
thead {
  position: -webkit-sticky;
  position: sticky;
  top: 0;
  z-index: 2;
}
thead th.blank {
  position: -webkit-sticky;
  position: sticky;
  top: 0;
  left: 0;
  z-index: 3;
}
.tabletimeline{
  z-index: 1001;
}
.tableheader{
  z-index: 1002;
}
</style>



// WEBPACK FOOTER //
// SpTable.vue?240f3aac